import React, { useEffect, useState } from "react";
import PopupModal from "../../../Components/ModalComponent/PopupModal";

import { ManageApis } from "../../../AppServices/ManageApi";
import TableComponent from "../../../Components/TableComponent/TableComponent";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../../Components/AlertBox/AlertBox";
import Loader from "../../../Components/LoaderComponent/Loader";
import InputComponent2 from "../../../Components/InputComponent/InputComponent2";
import {
  PreventNonNumeric,
  convertUtcToBrowserTimeZone,
  dataTableInitialLoader,
  emailValidation,
  formatingValue,
  preventSpecialChars,
  userValidation,
} from "../../../Functions/Utils";
import DataTable from "../../../Components/DataTable/DataTable";
import { Input } from "@arco-design/web-react";

const InputSearch = Input.Search;
function AccountList() {
  const initaialCreatMenu = {
    name: "",

  };

  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [searchText, setSearchText] = useState('')
  const [createAccount, setCreateAccount] = useState(initaialCreatMenu);
  const [show, setShow] = useState(false);
  const [visible, setvisible] = useState({ show: false, type: "" });
  const [showAlert, setShowAlert] = useState(AlertinitialValue);
  const [AccountList, setAcountList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [tableLoader, setTableLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const [formatedAccountList, setFormatedAccountList] = useState([]);
  const [editableRows, setEditableRows] = useState({});
  const [editingRowId, setEditingRowId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigate = useNavigate();

  let createMenuform = [
    {
      type: "text",
      name: "name",
      label: "Account Name",
      regex: /[^a-zA-Z\s]/g,
      max: 15,
    }


  ];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        // //console.log(record),
        editableRows[record.id] ? (
          <input
            type={"text"}

            className={`form-control  ${formatedAccountList?.filter((itm) => itm.id == record.id)[0][
              "name"
            ] == "" ? "isinvalid" : ""}`}
            value={
              formatedAccountList?.filter((itm) => itm.id == record.id)[0][
              "name"
              ]
            }
            onChange={(e) =>
              handleInputChange(record.id, "name", e.target.value)
            }
            disabled={!editableRows[record.id]}

          />
        ) : (
          text
        )
      ),
      width: "400px",
    },
    {
      title: "Created Date",
      dataIndex: "createdDate",

      render: (v, record) => {
        return (<div>{convertUtcToBrowserTimeZone(record.formattedCreateDate)}</div>)
      }

    },
    // {
    //   title: "Created By",
    //   dataIndex: "createdBy",
    //   render: (text, record) => (
    // //console.log(record),
    //     text?text:"N/A"
    //     ) 
    // },
    {
      title: "Action",
      dataIndex: "action",
      width: "200px",
      render: (v, record) => {
        return (
          // //console.log("sssssssssssssss", record),
          (
            <div className="d-flex justify-content-center">
              {editingRowId === record?.id ? (
                <>
                  <div className="col-12 ">
                    <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                      <button
                        className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleSave(record?.id)}
                      >
                        Save
                      </button>

                      <button
                        className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleCancel(record.id)}
                      >
                        Cancel
                      </button>
                      {/* <DeleteTwoTone /> */}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* Not in use */}
                  {/* <i
                      className="arco-icon-delete text-danger font_14 cursor-pointer ms-2"
                      onClick={() => handleDeleteMenu(record)}
                    /> */}
                  <div className="col-12 ">
                    <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
                      <button
                        className="  btn px_btn btn-master py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleEdit(record?.id)}
                      >
                        Edit
                      </button>
                      <button
                        className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                        onClick={() => handleDeleteMenu(record?.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          )
        );
      },
    },
  ];


  useEffect(() => {
    getAccountList();
  }, []);


  const handleInputChange = (id, field, value) => {
    // //console.log(id, field, value);

    const updatedData = formatedAccountList.map((item) =>
      item.id === id
        ? {
          ...item,
          [field]: formatingValue(value, 15, /[^a-zA-Z\s]/g)

        }
        : item
    );
    // //console.log(updatedData);
    setFormatedAccountList(updatedData);
  };
  const handleSave = async (param) => {
    // //console.log(formatedAccountList.filter((itm) => itm.id == param));

    // //"";
    try {

      let formateData = formatedAccountList.filter((itm) => itm.id == param)
      if (formateData[0]?.name !== "") {

        setIsLoading(true);

        let result = await ManageApis("post", global.AccountUpdate, formateData[0]);
        if (result.message === "Success") {
          setEditableRows({});
          setEditingRowId(null);

          setSelectedRows(selectedRows.filter((rowId) => rowId !== param));
          setIsLoading(false);

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Successfully Updated...!",
            isSuccess: true,
            isfalse: false,
          }));
        } else {
          setIsLoading(false);
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Somthing went wrong...!",
            isSuccess: false,
            isfalse: true,
          }));
        }
      }
    } catch (err) {
      // //console.log(err);
    }
    // You can implement the logic to save the changes here
  };
  const handleCancel = (id) => {
    const updatedEditableRows = { ...editableRows };
    delete updatedEditableRows[id];
    setEditableRows(updatedEditableRows);
    setEditingRowId(null);
    setFormatedAccountList(AccountList)
    setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
  };
  const getAccountList = async () => {
    try {
      setIsLoading(true);
      let response = await ManageApis("get", global.getAllAccount);
      // //console.log(response);
      if (response.message === "Success") {
        setIsLoading(false);
        setAcountList(response?.response_data.map((itm) => ({ ...itm, name: itm.accountName })));
        setFormatedAccountList(response?.response_data.map((itm) => ({ ...itm, name: itm.accountName })));
      } else {
        // //console.log(response);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
    }
  };
  const handleEdit = (id) => {
    setEditingRowId(id);
    setEditableRows((prevState) => ({
      [id]: !prevState[id], // Toggle edit mode for the clicked row
    }));
    setSelectedRows([id]);
  };

  const handleDeleteMenu = async (params) => {
    try {
      setIsLoading(true);
      const reqstBoady = {
        id: params
      }
      let result = await ManageApis(
        "post",
        `${global.AccountDelete}`, reqstBoady
      );
      if (result.message == "Success") {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Account Deleted Successfully",
          isSuccess: true,
        }));
        // call get menulist for update data here
      } else {
        setIsLoading(false);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: "Something Went wrong",
          isfalse: true,
        }));
        // //console.log(result);
      }
    } catch (err) {
      // //console.log(err);
    }
  };

  // create menu handlechange
  const handleChange = (e, regex, max) => {
    const { name, value } = e.target;
    // //""
    // //console.log(name, value,regex,max);

    switch (name) {
      case name:
        setCreateAccount((prevState) => ({
          ...prevState,
          [name]: regex ? formatingValue(value, max, regex) : value,
        }));
        handleError(null, [name]);
      default:
        break;
    }
  };

  const handleError = (error, input) => {
    setErrors((prevState) => ({ ...prevState, [input]: error }));
  };

  const handleAlertBoxCancel = () => {
    if (showAlert.isSuccess) {
      getAccountList();
      setShowAlert(AlertinitialValue);
    } else {
      setShowAlert(AlertinitialValue);
    }
  };

  // handle Add Menu
  const handleAddAccount = async () => {
    const validate = () => {
      let isValid = true;
      // ""
      let array = Object.keys(createAccount);
      let result = userValidation(createAccount, array);
      //validation message issue here
      result.forEach((item) => {
        handleError(`Please Enter the ${item.replace("_", " ")}`, item);
        isValid = false;
      });
      // //console.log(result);
      Object.keys(errors).forEach((key) => {
        if (errors[key]) {
          isValid = false;
          // //console.log(errors[key]);
        }
      });

      return isValid;
    };
    try {
      if (validate()) {
        setIsLoading(true);

        setShow(false);

        let result = await ManageApis("post", global.addAccount, createAccount);
        if (result.message == "Success") {
          // //console.log(result);
          setCreateAccount(initaialCreatMenu);
          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Account added successfully",
            isSuccess: true,
          }));
          setIsLoading(false);
        } else {
          setCreateAccount(initaialCreatMenu);
          setIsLoading(false);
          // //console.log(result);

          setShowAlert((pre) => ({
            ...pre,
            show: true,
            message: "Something went wrong...!",
            isSuccess: false,
            isfalse: true,
          }));
        }
      }
    } catch (err) {
      // //console.log(err);
    }
  };


  const onChangeTable = (pagination) => {
    // //"";
    // //console.log(pagination);

    const { current, pageSize } = pagination;
    // //console.log({ pageSize });
    setTableLoader(true);

    setFormatedAccountList(dataTableInitialLoader(columns));
    setTimeout(() => {
      setFormatedAccountList(
        AccountList.slice((current - 1) * pageSize, current * pageSize)
      );
      setPageSize(pageSize);
      setcurrentPage(current);
      setTableLoader(false);
    }, 2000);
  };
  const handlesearch = (value) => {
    setSearchText(formatingValue(value, 20, /[^a-zA-Z\s]/g))
    try {
      if (searchText) {
        setFormatedAccountList(() => (
          AccountList.filter((itm) => (itm?.name?.toLowerCase().includes(value?.toLowerCase())))
        ))
      } else {
        setFormatedAccountList(AccountList)
      }

    } catch (error) {
      // console.error("An error occurred:", error.message);
    }
  }

  return (
    <>
      {isLoading && <Loader />}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={handleAlertBoxCancel}
      />
      <div className="p-2">
        <section className="admin_Section ">
          <div
            className={`d-flex justify-content-between align-items-center ${AccountList?.length > 0 ? "" : "d-none"
              }`}
          >
            <h3 className="text_master2 mb-0 text-uppercase  py-2 font_18 fw_600">
              Account
            </h3>
            <div className="  flex-column flex-md-row g-1 d-flex gap-3 justify-content-between ">
              <div className=" arco_inputsearch ">

                <InputSearch value={searchText} onChange={handlesearch} allowClear placeholder='Enter Account name' />
              </div>
              <button
                className="btn btn-master font_14 px-4"
                onClick={() => setShow(true)}
              >
                Add Account +
              </button>

            </div>
          </div>
          <div className="table_type02 pb-4 pt-3 table-responsive custom_scroll1 h-100">
            {!AccountList?.length > 0 ? (
              <div className="d-flex  h-100">
                <div className="m-auto text-center">
                  <i className="fas fa-user-alt-slash font_18 mb-2"></i>
                  <div className="pb-2">Currently No Menu Available</div>
                  <button
                    className="btn btn-master font_14 px-4"
                    onClick={() => setShow(true)}
                  >
                    Add Menu +
                  </button>
                </div>
              </div>
            ) : (
              <DataTable
                loading={tableLoader}
                columnData={columns}
                rowData={formatedAccountList}
                current={currentPage}
                pageSize={pageSize}
                total={AccountList?.length}
                onChangeTable={onChangeTable}
              />
            )}
          </div>
        </section>
      </div>

      <PopupModal
        title="Enter Details"
        size="md"
        visible={show}
        handleClose={() => setShow(false)}
      >
        <div className="row align-items-center">
          <div className="col-12 text_m1 fw_500 d-none">Menu</div>
          <div className="col-12 pt-1 pt-sm-0 mb-3 mb-sm-0">
            <div className=" pt-2">
              <div className="data w-100">
                {createMenuform.map((itm) => (
                  <div
                    className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"
                      }`}
                  >
                    <InputComponent2
                      label={itm.label}
                      name={itm.name}
                      type={itm.type}
                      value={createAccount[itm.name]}
                      error={errors[itm.name]}
                      disabled={itm.isDisabled}
                      onchange={(e) => handleChange(e, itm?.regex, itm.max)}
                    />
                  </div>
                ))}

                {/* <select className="form-control pe-0">
                        <option>Adhaar Masking</option>
                        <option>User</option>
                      </select> */}
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-end">
              <button
                className="btn btn-master px-3 font_14"
                onClick={handleAddAccount}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </PopupModal>
    </>
  );
}

export default AccountList;
